import * as React from "react";

import { Person } from "../../../../models/Person";
import { DataGrid, Getter } from '../../../../components/DataGrid/DataGrid';
import { DataGridFlagValueColumn } from '../../../../components/DataGrid/DataGridFlagValueColumn';
import { DataGridTextColumn } from '../../../../components/DataGrid/DataGridTextColumn';
import { DataGridButtonColumn } from "../Columns/DataGridButtonColumn";
import { DataGridTemplateColumn, Props as TemplateProps } from "../../../../components/DataGrid/DataGridTemplateColumn";
import { IdColumn } from "../Columns/IdColumn";
import { MultiselectColumn, multiselectPropsFrom, MultiselectProps } from "../Columns/MultiselectColumn";
import { Polyglot } from "../../../../polyglot";
import { Button } from "../../../../components/Buttons";

interface Props extends MultiselectProps
{
    polyglot: Polyglot;
    isAdmin: boolean;
    items?: Person[];
    onEdit: (datum: any, row: number) => void;
}

const getterFirstName: Getter<Person> = p => p.Firstname;
const getterLastName: Getter<Person> = p => p.Lastname;
const getterUserName: Getter<Person> = p => p.Username;
const getterAdmin: Getter<Person> = p => p.IsAdministrator;

export const PersonGrid = (props: Props) =>
{
    const { items = [], isAdmin, onEdit, polyglot } = props; 
    
    return (
        <DataGrid initialData={items} className={props.className} onThead={props.onThead}>
            <MultiselectColumn {...multiselectPropsFrom(props)} />
            <IdColumn header={polyglot.t('column.id')} />
            <DataGridTextColumn header={polyglot.t('person.label_first_name')} getValue={getterFirstName} />
            <DataGridTextColumn header={polyglot.t('person.label_last_name')} getValue={getterLastName} />
            <DataGridTextColumn header={polyglot.t('person.label_username')} getValue={getterUserName} />
            <DataGridFlagValueColumn getValue={getterAdmin}
                header={polyglot.t('person.label_level')}
                trueTitle={polyglot.t('person.label_level_administrator')}
                falseTitle={polyglot.t('person.label_level_user')} />
            
            { isAdmin &&
                <DataGridTemplateColumn header={props.polyglot.t('column.action')} render={ p => {
                    const { datum, row } = p;
                    return (
                        <td className='btn-toolbar'>
                            <Button dim="xs" leftIcon="eye-open" type="info" onClick={e => props.onEdit(datum, row)}>{props.polyglot.t('button.view')}</Button>
                        </td>
                    );
                   }}
                />
            }
        </DataGrid>
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/PersonGrid.tsx